module.exports = __webpack_public_path__ + "static/media/manph.725afb83.jpg";